module.exports = __webpack_public_path__ + "img/bgProfile.6dca0228.png";